import React, { Component } from "react";

import AccountCircle from "@material-ui/icons/AccountCircle";
import AddCircle from "@material-ui/icons/AddCircle";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import Divider from "@material-ui/core/Divider";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import LanguageIcon from "@material-ui/icons/Language";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import SettingsIcon from "@material-ui/icons/Settings";
import Switch from "@material-ui/core/Switch";
import { withRouter } from "react-router-dom";

import { isAdmin } from "../../utility/user-actions";
import ApiDocsIcon from "../../components/ApiDocsIcon/ApiDocsIcon";
import AllureDockerInfoDialog from "../../components/AllureDockerInfoDialog/AllureDockerInfoDialog";
import AllureDockerLanguagesMenu from "../../components/AllureDockerLanguagesMenu/AllureDockerLanguagesMenu";

class AllureDockerMobileMenu extends Component {
  state = {
    infoDialog: false,
    languagesAnchorEl: null,
  };

  openInfoDialog = () => {
    this.setState({ infoDialog: true });
  };

  closeInfoDialog = () => {
    this.setState({ infoDialog: false });
  };

  closeLanguagesMenu = () => {
    this.setState({ languagesAnchorEl: null });
  };

  openLanguagesMenu = (event) => {
    this.setState({ languagesAnchorEl: event.currentTarget });
  };

  goToSwagger = () => {
    window.open(`${window._env_.ALLURE_DOCKER_API_URL}/swagger`, "_blank");
  };

  // Пункт действия сначала закрывает меню, иначе оно остаётся поверх
  // открывшегося диалога.
  runAndClose = (action) => () => {
    this.props.handleMobileMenuClose();
    if (action) {
      action();
    }
  };

  render() {
    return (
      <React.Fragment>
        <Menu
          anchorEl={this.props.anchorEl}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          id="primary-search-account-menu-mobile"
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={this.props.isMobileMenuOpen}
          onClose={this.props.handleMobileMenuClose}
        >
          {/* Действия, которые ниже md убраны из тулбара: там они переполняли
              его и обрезались вместе с кнопкой, открывающей это меню. */}
          <MenuItem onClick={this.runAndClose(this.props.goToHome)}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <p>Home</p>
          </MenuItem>
          {this.props.isSignInAnOption && (
            <MenuItem onClick={this.runAndClose(this.props.goToSignIn)}>
              <ListItemIcon>
                <AccountCircle />
              </ListItemIcon>
              <p>Sign In</p>
            </MenuItem>
          )}
          <MenuItem
            onClick={this.runAndClose(this.props.openNewProjectDialog)}
            disabled={!isAdmin()}
          >
            <ListItemIcon>
              <AddCircle />
            </ListItemIcon>
            <p>New Project</p>
          </MenuItem>
          <MenuItem
            onClick={this.runAndClose(this.props.openNewFolderDialog)}
            disabled={!isAdmin()}
          >
            <ListItemIcon>
              <CreateNewFolderIcon />
            </ListItemIcon>
            <p>New Folder</p>
          </MenuItem>
          <MenuItem onClick={this.runAndClose(this.props.openConfigDialog)}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <p>Settings</p>
          </MenuItem>
          {this.props.isLogoutNeeded && (
            <MenuItem onClick={this.runAndClose(this.props.openSignOutDialog)}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <p>Sign Out</p>
            </MenuItem>
          )}
          <Divider />

          {/* Иконки здесь декоративные: обработчик и видимая подпись живут на
              самом MenuItem. Раньше они были обёрнуты в IconButton — это
              фокусируемый <button> внутри role="menuitem", то есть невалидная
              вложенность и лишние таб-стопы. ListItemIcon — штатная композиция. */}
          <MenuItem>
            <Switch
              checked={this.props.darkState}
              onChange={this.props.handleThemeChange}
              inputProps={{
                "aria-label": this.props.darkState ? "switch to light mode" : "switch to dark mode",
              }}
            />
            <p>Dark Mode</p>
          </MenuItem>
          <MenuItem onClick={this.openLanguagesMenu}>
            <ListItemIcon>
              <LanguageIcon />
            </ListItemIcon>
            <p>Language</p>
          </MenuItem>
          <MenuItem onClick={this.openInfoDialog}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <p>Info</p>
          </MenuItem>
          <MenuItem onClick={this.goToSwagger}>
            <ListItemIcon>
              <ApiDocsIcon />
            </ListItemIcon>
            <p>API Docs</p>
          </MenuItem>
        </Menu>
        <AllureDockerInfoDialog
          open={this.state.infoDialog}
          handleCloseDialog={this.closeInfoDialog}
        />
        {/* setAPIAlert обязателен: без него handleAPISuccessAlert падает с
            TypeError, а refreshCurrentPageInSeconds стоит строкой ниже и не
            выполняется — запрос уходит, страница не перезагружается, язык не
            меняется. Отсюда меню открывается на всех ширинах < 1240px. */}
        <AllureDockerLanguagesMenu
          closeLanguagesMenu={this.closeLanguagesMenu}
          anchorEl={this.state.languagesAnchorEl}
          setAPIAlert={this.props.setAPIAlert}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(AllureDockerMobileMenu);
